import React, { FunctionComponent, ReactNode } from "react";
import { FixMeLater } from "types";
import { useSelector } from "react-redux";
import { Route } from "react-router-dom";
import { RouteComponentProps } from "react-router";
import { IS_WHOP, NEXT_URL_QUERY_PARAM } from "common/constants";
import useHistoryWithQuery from "utils/hooks/useHistoryWithQuery";
import useQuery from "utils/hooks/useQuery";
import RedirectWithQuery from "common/Routes/RedirectWithQuery";
import { sharedLib } from "@shared/services/shared.service";

interface PrivateRouteProps {
  component?: FunctionComponent<any>;
  render?: (props?: RouteComponentProps) => ReactNode;
  path: string | string[];
  rest?: FixMeLater;
}

const PrivateRoute = ({
  component: Component,
  render,
  path,
  ...rest
}: PrivateRouteProps) => {
  const token = useSelector(sharedLib.selectors.authentication.selectToken);
  const { getUpdatedPath } = useHistoryWithQuery();
  const query = useQuery();
  const parsedQuery = Object.fromEntries(query);

  const privateRouteRender = (props?: RouteComponentProps) => {
    if (!token && !IS_WHOP) {
      const pathname = props?.location.pathname;
      let nextPath = "/login";
      let updatedQuery: Record<string, string> | undefined;
      const hasQuery = Object.keys(parsedQuery).length;
      if (hasQuery) {
        updatedQuery = parsedQuery;
      }
      if ((pathname && pathname !== "/") || hasQuery) {
        updatedQuery = {
          ...updatedQuery,
          [NEXT_URL_QUERY_PARAM]: pathname || "/",
        };
      }
      if (updatedQuery) {
        nextPath = getUpdatedPath(updatedQuery, undefined, nextPath);
      }
      return <RedirectWithQuery to={nextPath} />;
    } else if (render) {
      return render();
    } else if (Component) {
      return <Component />;
    }
    return null;
  };

  return <Route {...rest} path={path} render={privateRouteRender} />;
};

export default PrivateRoute;
